import React from 'react';
import { OverflowCell } from '../../../../components/OverflowCell';

interface ItemsDisplayProps {
  items: Array<{
    id: string | number;
    type: string;
    order: number;
    name?: string;
  }>;
  maxWidth?: number;
}

const getItemTypeLabel = (type: string) => {
  switch (type) {
    case 'rawMaterial': return 'Matéria Prima';
    case 'service': return 'Serviço';
    case 'resource': return 'Insumo';
    case 'productFinal': return 'Produto Manufaturado';
    default: return type;
  }
};

const ItemsDisplay: React.FC<ItemsDisplayProps> = ({ items, maxWidth = 200 }) => {
  const itemsText = items.map(item => `${item.order}. ${item.name || 'Item sem nome'} (${getItemTypeLabel(item.type)})`).join('\n');
  const inlineText = items.length > 0
    ? items.map(item => `${item.order}. ${item.name || 'Item sem nome'} (${getItemTypeLabel(item.type)})`).join(', ')
    : 'Nenhum item';

  return (
    <OverflowCell text={itemsText} maxWidth={maxWidth} forceTooltip={items.length > 1}>
      {inlineText}
    </OverflowCell>
  );
};

export default ItemsDisplay; 